import styles from "./index.module.css";
import DataList, { DataRow } from "shared/DataList";

import { Empty } from "../index";

export default function ({ record }) {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.headerText}>Details</h3>
      </header>

      <DataList>
        <DataRow label="Order ID">{record.id}</DataRow>
        <DataRow label="Last Name">{record.lastName}</DataRow>
        <DataRow label="Status">{record.status}</DataRow>
        <DataRow label="Subtotal">
          {(record.subTotal && record.subTotal.toFixed(2)) || <Empty />}
        </DataRow>
        <DataRow label="Tax">
          {(record.tax && record.tax.toFixed(2)) || <Empty />}
        </DataRow>
        <DataRow label="GST">
          {(record.GST && record.GST.toFixed(2)) || <Empty />}
        </DataRow>
        <DataRow label="Shipping">
          {(record.shipping && record.shipping.toFixed(2)) || <Empty />}
        </DataRow>
        <DataRow label="Total">
          {(record.total && record.total.toFixed(2)) || <Empty />}
        </DataRow>
        <DataRow label="CC Transaction">
          {record.ccTransactionId != null && record.ccTransactionId !== -1 ? (
            record.ccTransactionId
          ) : (
            <Empty />
          )}
        </DataRow>
        <DataRow label="AH Trace ID">
          {record.ahTraceId != null && record.ahTraceId !== -1 ? (
            record.ahTraceId
          ) : (
            <Empty />
          )}
        </DataRow>
        <DataRow label="HC Trace ID">
          {record.hcTraceId != null && record.hcTraceId !== -1 ? (
            record.hcTraceId
          ) : (
            <Empty />
          )}
        </DataRow>
      </DataList>
    </div>
  );
}
